var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropelLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 48,
    viewBox: "0 0 163 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0618 22.1208V29.964L19.5239 38.9324L11.7505 34.4396V26.6053L19.5239 31.0981L35.0618 22.1208Z",
    fill: "#8C7C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3319 9.79468V17.6379L11.7939 26.6062L4.02051 22.1134V14.2792L11.7939 18.772L27.3319 9.79468Z",
    fill: "#8C7C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1929 9.56958H54.7695C59.9711 9.56958 64.4588 12.9677 64.4588 18.9667C64.4588 25.0064 59.9711 28.4045 54.7695 28.4045H47.7647V38.9321H43.1929V9.56958ZM54.477 24.4195C57.7913 24.4195 60.014 22.2381 60.014 18.9667C60.014 15.7363 57.7913 13.5545 54.477 13.5545H47.7647V24.4195H54.477Z",
    fill: "#8C7C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1396 18.1694H70.5461V20.9786C72.2654 18.6724 74.9502 17.7911 78.5569 17.834V22.4897C77.5918 22.1114 76.7944 22.0276 75.8293 22.0276C73.1038 22.0276 70.5461 24.2519 70.5461 28.4046V38.9326H66.1396V18.1694Z",
    fill: "#8C7C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5181 28.5293C78.5181 22.4464 83.4659 17.5396 89.5488 17.5396C95.6723 17.5396 100.622 22.4464 100.622 28.5293C100.622 34.569 95.6723 39.4781 89.5488 39.4781C83.4659 39.4781 78.5181 34.569 78.5181 28.5293ZM96.0505 28.5722C96.0505 24.712 93.1984 21.7351 89.5488 21.776C85.8992 21.7351 83.0899 24.712 83.0899 28.5722C83.0899 32.3895 85.8992 35.3667 89.5488 35.3258C93.1984 35.3667 96.0505 32.3895 96.0505 28.5722Z",
    fill: "#8C7C73"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.999998
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.763 18.1689H107.169V21.1459C108.889 19.175 111.155 17.8745 114.802 17.8745C120.466 17.8745 124.702 22.5302 124.702 28.5721C124.702 34.5689 120.466 39.2265 114.802 39.2265C111.155 39.2265 108.889 37.8832 107.169 35.9961V49.4188H102.763V18.1689ZM120.298 28.5721C120.298 24.671 117.486 21.6918 113.753 21.6918C110.022 21.6918 107.169 24.671 107.169 28.5721C107.169 32.4304 110.022 35.4092 113.753 35.4092C117.486 35.4092 120.298 32.4304 120.298 28.5721Z",
    fill: "#8C7C73"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.976 28.1938C146.976 28.6968 146.976 29.1589 146.936 29.7048H129.652C130.114 33.5631 133.009 35.8284 136.448 35.8284C139.006 35.8284 141.272 34.7365 142.615 33.0172L145.3 35.2824C143.369 37.9669 139.93 39.4351 136.448 39.4351C130.282 39.4351 125.583 34.6117 125.583 28.572C125.583 22.3624 130.241 17.5823 136.448 17.5823C142.448 17.5823 146.851 21.6511 146.976 28.1938ZM129.738 26.8095H143.034C142.321 23.1599 139.888 21.0213 136.448 21.0213C132.967 21.0213 130.366 23.3276 129.738 26.8095Z",
    fill: "#8C7C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.104 38.9322H148.921V7.47168H153.104V38.9322Z",
    fill: "#8C7C73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.56,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropelLogo);
export default __webpack_public_path__ + "static/media/propel-logo.87e0973f.svg";
export { ForwardRef as ReactComponent };